import React from "react"

import PlaceholderImage from "components/PlaceholderImage"

const ReceiptViewHeader = ({ headline, introCopy, headerImage}) => {
  
  const imageUrl = headerImage && headerImage.id ? `${process.env.SITE_ASSET_URL}/${headerImage.id}` : null
  const alt = headerImage && headerImage.alt ? headerImage.alt : "" 
  return (
    <div className={`receipt-view-header`}>
      {headline && (
        <h2 className="receipt-header-headline">
          <span dangerouslySetInnerHTML={{ __html: headline }} />
        </h2>
      )}
      {introCopy && <p className="receipt-header-desc" dangerouslySetInnerHTML={{ __html: introCopy }} />}
      {imageUrl && (
        <div className={`receipt-view-header-image`}>
          <PlaceholderImage src={imageUrl} width={1490} height={624} alt={alt} />
          
        </div>
      )}
    </div>
  )
}
export default ReceiptViewHeader
